import { render } from "./Jumbo.vue?vue&type=template&id=b871da04"
import script from "./Jumbo.vue?vue&type=script&lang=js"
export * from "./Jumbo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__